import { Input as InputForm } from "@/components/Input";
import { useLoading } from "@/contexts/LoadingContext";
import { useBasicHasRegister, useForgotPassword } from "@/hooks/Auth";
import { useEmpty } from "@/utilsV2";
import { Button, Flex, Text, useToast } from "@chakra-ui/react";
import Router from "next/router";
import { useState } from "react";

function CardRequestNewPassword() {
  const { setActionIsLoading } = useLoading();
  const [Email, setEmail] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const toast = useToast({
    position: "bottom",
    duration: 5000,
    isClosable: true
  });

  const HandleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    e.stopPropagation();

    if (useEmpty(Email)) {
      setIsLoading(false);
      toast({
        title: "É necessário informar seu Email!",
        status: "error"
      });
      return false;
    }

    const [HasRegisterData, HasRegisterError, HasRegisterLoading] = await useBasicHasRegister({
      UserEmail: Email
    });
    if ((HasRegisterData === null && HasRegisterError) || !HasRegisterData.status) {
      setIsLoading(false);
      toast({
        title: HasRegisterError ? HasRegisterError[0] : "Erro ao verificar seu Email!",
        description: HasRegisterError ? HasRegisterError[1] : HasRegisterData.msgs[0],
        status: "error"
      });
    } else {
      const [SendEmailData, SendEmailError, SendEmailLoading] = await useForgotPassword({
        email: Email,
        created: false,
        site: "LINGLONG",
        referer: null
      });

      if (SendEmailData && SendEmailError === null) {
        setIsLoading(false);
        toast({
          title: "Email enviado com sucesso!",
          description:
            "Verifique sua caixa de entrada! Você será redirecionado para a página inicial.",
          status: "success",
          duration: 8000
        });
        return Router.push("/");
      } else {
        setIsLoading(false);
        toast({
          title: SendEmailError ? SendEmailError[0] : "Erro ao enviar o Email!",
          description: SendEmailError ? SendEmailError[1] : SendEmailData,
          status: "error"
        });
        return false;
      }
    }
  };

  return (
    <Flex w="full" justifyContent="center" mt={["20px", "50px"]}>
      <Flex
        width={["90%", "32rem"]}
        direction="column"
        alignItems="center"
        as="form"
        onSubmit={HandleSubmit}
      >
        <Flex
          h={"130px"}
          alignItems="center"
          justifyContent={"center"}
          direction={"column"}
          bg={"#ECECEC"}
          borderRadius={"5px"}
        >
          <Text textStyle={"Bold"} textAlign={"center"} w={"80%"} fontSize={"20px"} mb={"10px"}>
            Recuperação de senha
          </Text>
          <Text textStyle={"Regular"} textAlign={"center"} w={"80%"} fontSize={"16px"}>
            Digite seu e-mail, e enviaremos um link para sua caixa de entrada.
          </Text>
        </Flex>

        <InputForm
          name="email"
          type="email"
          border={"1px solid #ECECEC"}
          borderRadius={"5px"}
          placeholder="E-mail"
          id={"ForgotEmail"}
          value={Email}
          isDisabled={IsLoading}
          onChange={(e) => setEmail(e.target.value)}
          w="full"
          mt={4}
        />
        <Flex alignItems={"center"} mt={"1rem"} w={"full"} gap={"10px"}>
          <Button
            w={["40%", "40%"]}
            h="50px"
            borderRadius={"5px"}
            flex={"10rem"}
            bg={"#121212"}
            color={"white"}
            textStyle={"Bold"}
            type={"button"}
            _hover={{ opacity: "80%" }}
            onClick={() => {
              setActionIsLoading(true);
              Router.push("/");
            }}
          >
            VOLTAR
          </Button>
          <Button
            w={["60%", "60%"]}
            h="50px"
            borderRadius={"5px"}
            flex={"10rem"}
            textStyle={"Bold"}
            bg={"#128A15"}
            color={"white"}
            type="submit"
            loadingText="Enviando..."
            isLoading={IsLoading}
            _hover={{ opacity: "80%" }}
          >
            <Text>ENVIAR EMAIL</Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}

export { CardRequestNewPassword };
